module.exports = __webpack_public_path__ + "static/media/advisor-1@2x.68f77874.jpg";